export default __webpack_public_path__ + "static/media/no-requests-found.c4abb93d.png";